// src/shared/composables/deliveryOptionsPayload.ts
//
// Eightpoint: turn the create-form's delivery options into request fields.
// Only fields that differ from upstream behaviour are sent, so a plain secret
// produces the same request as before (apart from recipient now being a list).

import { parseRecipientList } from '@/schemas/shapes/v3/delivery-options';

interface DeliveryFormFields {
  recipient?: string;
  max_views?: number;
  verify_recipient?: boolean;
}

export function deliveryOptionsPayload(form: DeliveryFormFields): Record<string, unknown> {
  const recipients = parseRecipientList(form.recipient);
  const payload: Record<string, unknown> = { recipient: recipients };

  const maxViews = Number(form.max_views ?? 1);
  if (Number.isInteger(maxViews) && maxViews > 1) {
    payload.max_views = maxViews;
  }

  if (form.verify_recipient && recipients.length > 0) {
    payload.verify_recipient = true;
  }

  return payload;
}
